export default __webpack_public_path__ + "static/media/wordsearch_preex.781ca504.svg";